import { getOffset } from "../helpers/html-utils";
import { onDisplay } from "../helpers/support";
import { getAllInstancesByElement, getAllInstancesByName, getAnyInstancesByElement } from "../../core";
import GridStackys from "./grid-stackys";
import GridSwitchys from "./grid-switchys";
/**
 * This object have to manage the element that are on the sidebar
 * @param _elements the sidebar elements
 * @param grid the grid
 * @param initDesk tell if the init has been done on desk or no, in order to calculate it when resizing
 */

export default class GridSides {
  private elements: HTMLElement[];
  private grid: HTMLElement;
  private initDesk: boolean;
  // manage the objects that can travel to the content part of the grid
  private switchy: GridSwitchys;
  // old way to stick element within the grid
  private sticky: any;
  // new way to stick those elements
  private stacky: any;
  private active: boolean;
  private enhanced =
    document.querySelectorAll(".tab").length > 0 ? true : false;
  private waitLoad = 0;
  private top0: any[] = [];

  constructor(elements: HTMLElement[], grid: HTMLElement, initDesk: boolean) {
    this.elements = elements;
    this.grid = grid;
    this.initDesk = initDesk;
    this.init();
  }
  init(): void {

    if (this.initDesk) {
      for (let i = 0; i < this.elements.length; i++) {
        const style = this.elements[i].style;
        let v = parseInt((style.top + "").split("px").join(""));
        if (v + "" == "NaN") {
          v = 0;
        }
        this.top0.push(v);
      }

      window.addEventListener('resize', () => this.reload())

      this.load();
    }

    PubSub.subscribe("render-grid-side", () => {
      this.reload();
    });
  }

  reload(): void {
    if (this.initDesk) {
      this.load();
      if (this.sticky) {
        this.sticky.reload();
      }
      if (this.stacky?.reload) {
        this.stacky.reload();
      }
    }
  }
  load(): void {
    if (this.initDesk) {
      let cumulHeight = 0;
      if (this.top0.length > 0) {
        cumulHeight = this.top0[0];
      }
      let sheetremover = 0;
      for (let i = 0; i < this.elements.length; i++) {
        this.elements[i].style.position = "absolute";
        if (
          this.elements[i].classList.contains("se") ||
          (this.elements[i].classList.contains("endsheet") &&
            !this.elements[i].classList.contains("sheet"))
        ) {
          sheetremover++;
        }
        const he = cumulHeight + (i - sheetremover) * 30;

        this.elements[i].style.top = he + "px";
        this.elements[i].style.display = "block";
        const offset = getOffset(this.elements[i]);
        cumulHeight += offset.height;
      }

      this.grid.style.minHeight = cumulHeight + (30 * this.elements.length) + "px";
    }
    onDisplay(
      this.grid,
      () => {
        this.active = window.innerWidth > 767;
      },
      () => {
        this.active = false;
      }
    );

    const TabLayoutInstances = getAllInstancesByName("TabLayout");
    if (TabLayoutInstances.length) {
      for (const instance of TabLayoutInstances) {
        if (instance.getElement() === this.grid) {
          this.active = instance.isShowing() && window.innerWidth > 767;
          PubSub.subscribe("TabLayout-changed", () => {
            this.active = instance.isShowing() && window.innerWidth > 767;
            if (!this.waitLoad) {
              this.switch();
            }
          });
        } else {
          this.active = !(instance.isShowing() && window.innerWidth > 767);
          PubSub.subscribe("TabLayout-changed", () => {
            this.active = !(instance.isShowing() && window.innerWidth > 767);
            if (!this.waitLoad) {
              this.switch();
            }
          });
        }
      }
    } else {
      this.active = true;
      if (!this.waitLoad) {
        this.switch();
      }
    }

    window.addEventListener("scroll", () => {
      if (this.active) {
        this.switch();
        if (!this.stacky) {
          const stacks = [];
          for (let i = 0; i < this.elements.length; i++) {
            if (this.elements[i].hasAttribute("data-grid-stack")) {
              if (this.grid && this.grid == this.elements[i].parentNode) {
                stacks.push(this.elements[i]);
              }
            }
          }

          if (stacks.length) {
            this.stacky = new GridStackys(stacks, this.grid, this.elements);
          } else {
            this.stacky = true;
          }
        }
      }
    });

    PubSub.publish("GridSides-loaded");
  }
  switch(): void {
    if (this.active && !this.switchy) {
      const switchs = [];
      for (let i = 0; i < this.elements.length; i++) {
        if (this.elements[i].hasAttribute("data-grid-switch")) {
          if (this.grid && this.grid == this.elements[i].parentNode) {
            switchs.push(this.elements[i]);
          }
        }
      }
      if (switchs.length) {
        this.switchy = new GridSwitchys(switchs, this.grid);
        const sw = this.switchy.do();
        let sideheight = sw.sideheight;
        if (sideheight > 1000) {
          sideheight = 1000;
        }
        this.grid.style.minHeight = sideheight + "px";
        for (let zut = 0; zut < sw.removed.length; zut++) {
          const idx = this.elements.indexOf(sw.removed[zut]);
          this.elements.splice(idx, 1);
        }
      }
    }
  }
}
